module.exports = __webpack_public_path__ + "static/media/headphones.080b0e87.png";